import(/* webpackMode: "eager" */ "/codebuild/output/src2755445382/src/car-x-frontend/src/app/global-error.tsx");
